import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import React from 'react'
import { TextInput } from 'react-admin'

const styles = (theme) => ({
  root: {
    '& tr': {
      backgroundColor: 'transparent',
      '& td': {
        verticalAlign: 'middle',
      },
    },
  },
})

const Dictionary = ({ classes, label, sources = [], baseSource = false }) => {
  return (
    <Table className={classes.root}>
      <TableHead>
        <TableRow>
          <TableCell colSpan={2}>{label}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {sources.map((source) => (
          <TableRow key={source}>
            <TableCell>{source}</TableCell>
            <TableCell>
              <TextInput label="" source={baseSource ? `${baseSource}.${source}` : source} fullWidth />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default withStyles(styles)(Dictionary)
